import missionControlPublisher from './missionControlPublisher';

export default {
  ...missionControlPublisher.campaign,
  radioDesc: `By selecting allow, your campaign will only target the specified applications.
  By selecting deny, your campaign will not target the specified applications.`,
};
